(() => {
  const syncProductRating = (root = document) => {
    const reviewSummary =
      root.querySelector('[data-product-review-summary]') || document.querySelector('[data-product-review-summary]');
    const ratingSummary = document.querySelector('[data-product-rating-summary]');
    if (!reviewSummary || !ratingSummary) return;

    const reviewCount = Number.parseInt(reviewSummary.dataset.reviewCount || '0', 10);
    const reviewAverage = Number.parseFloat(reviewSummary.dataset.reviewAverage || '0');
    if (reviewCount < 1 || !Number.isFinite(reviewAverage)) return;

    const roundedRating = Math.max(0, Math.min(5, Math.round(reviewAverage)));
    const stars = `${'★'.repeat(roundedRating)}${'☆'.repeat(5 - roundedRating)}`;
    const formattedAverage = reviewAverage.toLocaleString('tr-TR', { maximumFractionDigits: 1 });

    const starElement = document.createElement('span');
    starElement.className = 'playhouse-review-stars';
    starElement.setAttribute('aria-hidden', 'true');
    starElement.textContent = stars;

    const textElement = document.createElement('span');
    textElement.className = 'playhouse-rating-link__text';
    textElement.textContent = `${formattedAverage} · ${reviewCount} değerlendirme`;

    ratingSummary.replaceChildren(starElement, textElement);
    ratingSummary.setAttribute('aria-label', `${formattedAverage} / 5, ${reviewCount} değerlendirme`);
  };

  const initializeStickyBuyBar = (root = document) => {
    root.querySelectorAll('[data-playhouse-mobile-sticky]').forEach((stickyBar) => {
      if (stickyBar.dataset.initialized === 'true') return;

      const sectionId = stickyBar.dataset.sectionId;
      const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const stickyButton = stickyBar.querySelector('button[type="submit"]');
      const stickyPrice = stickyBar.querySelector('[data-sticky-price]');
      if (!mainButton || !stickyButton) return;

      stickyBar.dataset.initialized = 'true';

      const observer = new IntersectionObserver(
        ([entry]) => {
          const shouldShow = !entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', shouldShow);
        },
        { rootMargin: '0px 0px -72px 0px', threshold: 0 }
      );

      observer.observe(mainButton);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== sectionId) return;

          const sourcePrice = document.querySelector(
            `#price-${sectionId} .price-item--sale, #price-${sectionId} .price-item--regular`
          );
          if (sourcePrice && stickyPrice) stickyPrice.textContent = sourcePrice.textContent.trim();

          const unavailable = event.data.variant == null || event.data.variant.available === false;
          stickyButton.disabled = unavailable;
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeStickyBuyBar();
      syncProductRating();
    });
  } else {
    initializeStickyBuyBar();
    syncProductRating();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeStickyBuyBar(event.target);
    syncProductRating(event.target);
  });
})();
